export default __webpack_public_path__ + "static/media/abdel.35aa999e.jpeg";